import type { IntegerId } from '@cnapse/shared/data.types.js';

export type MobileScanStep =
  | { kind: 'camera'; containerId?: IntegerId }
  | { kind: 'label-pick'; barcode: string; containerId?: number }
  | { kind: 'label-linked'; barcode: string; entityType: string; entityId: number; entityName?: string }
  | { kind: 'label-done'; barcode: string; containerId: number; containerName: string }
  | { kind: 'node-pick'; nodeId: string; containerId?: number }
  | { kind: 'node-linked'; nodeId: string; containerId: number; containerName: string }
  | { kind: 'node-done'; nodeId: string; containerId: number; containerName: string };

export function parseMobileScanStep(cleanPath: string, search: string): MobileScanStep {
  const params = new URLSearchParams(search);
  const containerIdParam = params.get('containerId');
  const presetContainerId =
    containerIdParam !== null && Number.isFinite(Number(containerIdParam))
      ? Number(containerIdParam)
      : undefined;

  if (cleanPath === '/m/scan/label/pick') {
    const barcode = params.get('barcode')?.trim() ?? '';
    return { kind: 'label-pick', barcode, containerId: presetContainerId };
  }
  if (cleanPath === '/m/scan/label/linked') {
    return {
      kind: 'label-linked',
      barcode: params.get('barcode') ?? '',
      entityType: params.get('entityType') ?? 'container',
      entityId: Number(params.get('entityId')),
      entityName: params.get('entityName') ?? undefined,
    };
  }
  if (cleanPath === '/m/scan/label/done') {
    return {
      kind: 'label-done',
      barcode: params.get('barcode') ?? '',
      containerId: Number(params.get('containerId')),
      containerName: params.get('containerName') ?? 'Container',
    };
  }
  if (cleanPath === '/m/scan/node/pick') {
    return {
      kind: 'node-pick',
      nodeId: params.get('nodeId')?.trim() ?? '',
      containerId: presetContainerId,
    };
  }
  if (cleanPath === '/m/scan/node/linked') {
    return {
      kind: 'node-linked',
      nodeId: params.get('nodeId') ?? '',
      containerId: Number(params.get('containerId')),
      containerName: params.get('containerName') ?? '',
    };
  }
  if (cleanPath === '/m/scan/node/done') {
    return {
      kind: 'node-done',
      nodeId: params.get('nodeId') ?? '',
      containerId: Number(params.get('containerId')),
      containerName: params.get('containerName') ?? '',
    };
  }

  return {
    kind: 'camera',
    containerId:
      presetContainerId !== undefined ? (presetContainerId as IntegerId) : undefined,
  };
}

export function mobileScanStepHidesBottomNav(step: MobileScanStep): boolean {
  return step.kind !== 'camera' && step.kind !== 'label-done' && step.kind !== 'node-done';
}
